import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	categories: [],
	cities: [],
	provinces: [],
	openKey: "",
	selectedKey: "",
	user: {
		permissions: [],
	},
};

export const appSlice = createSlice({
	name: "app",
	initialState,
	reducers: {
		openMenu: (state, action) => {
			state.openKey = action.payload;
		},
		setRoute: (state, action) => {
			state.openKey = action.payload.openKey;
			state.selectedKey = action.payload.selectedKey;
		},
		updateCities: (state, action) => {
			state.cities = action.payload;
		},
		updateProvinces: (state, action) => {
			state.provinces = action.payload;
		},
		updateSettings: (state, action) => {
			state.settings = action.payload;
		},
		updateUser: (state, action) => {
			state.user = action.payload;
		},
	},
});

export const {
	openMenu,
	setRoute,
	updateCategories,
	updateCities,
	updateProvinces,
	updateSettings,
	updateUser,
} = appSlice.actions;

export default appSlice.reducer;
